import {
  GET_PAINT_TREATMENT_GRADES,
  GET_PAINT_TREATMENT_GRADE,
  CREATE_PAINT_TREATMENT_GRADE,
  UPDATE_PAINT_TREATMENT_GRADE,
  DESTROY_PAINT_TREATMENT_GRADE,
} from "./actions";

export function PaintTreatmentGradesReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PAINT_TREATMENT_GRADES}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PAINT_TREATMENT_GRADE}_FULFILLED`:
    case `${CREATE_PAINT_TREATMENT_GRADE}_FULFILLED`:
    case `${UPDATE_PAINT_TREATMENT_GRADE}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    case `${DESTROY_PAINT_TREATMENT_GRADE}_FULFILLED`: {
      let newState = _.clone(state);
      const deletedItem = action.payload.data;
      const id = _.get(deletedItem, "id");
      newState = _.filter(newState, (i) => i.id != id);
      return newState;
    }
    default:
      return state;
  }
}

// Move this to the reducer page
// import { PaintTreatmentGradesReducer } from "modules/paint/treatment_grades/reducer"

// paint_treatment_grades:PaintTreatmentGradesReducer,
